import { RouteNames } from 'models'
import { IdpRequestError } from 'models/errors'
import ErrorPage from 'pages/ErrorPage'
import { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useNavigate } from 'react-router-dom'

interface AppErrorBoundaryProps {
  children: ReactNode
}

const AppErrorBoundary = (props: AppErrorBoundaryProps) => {
  const navigate = useNavigate()

  const handleError = (error: Error) => {
    if (error instanceof IdpRequestError) {
      navigate(-1)
      window.location.reload()
    }
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onError={handleError}
      onReset={() => {
        navigate(RouteNames.home)
      }}>
      {props.children}
    </ErrorBoundary>
  )
}

export default AppErrorBoundary
